const SOUND_CLOUD_TYPE = 'wix-draft-plugin-sound-cloud';
export { SOUND_CLOUD_TYPE };
